/* eslint-disable import/order */
import React from 'react';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { getBusinessProjectResources } from '@jira/router-resources__business-common/src/getBusinessProjectResources.tsx';
// eslint-disable-next-line jira/import/no-restricted-import
import { licenseDetailsResource_DEPRECATED_DO_NOT_USE } from '@jira/router-resources__business-license-details/src/useIsPremiumUserSeat.tsx';
import type ForgeProjectSettingsPageType from '@jira/spa-apps__forge-project-settings/src/ForgeProjectSettingsPageShellWithAnalytics.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { coreProjectLayout } from '@jira/platform__layouts-core-project-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { projectSettingsCoreForgeAppsRoute } from '@jira/router-routes__project-settings-core-routes/src/projectSettingsCoreForgeAppsRoute.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import { getNavigationSidebarProjectSettingsResource } from './common/getNavigationSidebarProjectSettingsResource.tsx';
import type { Route } from '@atlassian/react-resource-router';

const LazyForgeProjectSettingsPage = lazyForPaint<typeof ForgeProjectSettingsPageType>(
	() =>
		import(
			/* webpackChunkName: "async-forge-spa-project-settings", jiraSpaEntry: "async-forge-spa-project-settings" */ '@jira/spa-apps__forge-project-settings/src/ForgeProjectSettingsPageShellWithAnalytics.tsx'
		),
);

const ForgeProjectSettingsPage = () => (
	<LazyPage
		Page={LazyForgeProjectSettingsPage}
		pageId="forge-spa-project-settings"
		shouldShowSpinner
	/>
);

export const projectSettingsCoreForgeAppsRouteEntry: Route = createEntry(
	projectSettingsCoreForgeAppsRoute,
	() => ({
		group: 'project-settings-core',

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		layout: coreProjectLayout,

		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
			// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
			projectContextResource,
			forgeProjectModuleResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			// end of resources expanded from getNavigationSidebarProjectResource
			...getNavigationSidebarProjectSettingsResource(),
			...getBusinessProjectResources(),
			licenseDetailsResource_DEPRECATED_DO_NOT_USE,
		],

		// eslint-disable-next-line no-restricted-syntax
		component: ForgeProjectSettingsPage,
		forPaint: [LazyAtlassianNavigation, LazyForgeProjectSettingsPage],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
